module.exports = __webpack_public_path__ + "c3648e6d720ffb24803ec06604591a77.png";